import { render, staticRenderFns } from "./MergeAccountsUser.vue?vue&type=template&id=543dcf74"
import script from "./MergeAccountsUser.vue?vue&type=script&lang=js"
export * from "./MergeAccountsUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports